import { render, staticRenderFns } from "./myCartProperty.vue?vue&type=template&id=479a9018"
import script from "./myCartProperty.vue?vue&type=script&lang=js"
export * from "./myCartProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports